"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { useBrand } from "@/app/(components)/specifics/wrappers/BrandProvider/BrandProvider";
import { ProjectStore } from "@/app/stores/ProjectStore";
import { Globals } from "@/app/vars/Globals";
import { ProtectedPaths } from "@/app/vars/Routes";

function stripLocale(pathname: string, lang: string): string {
  return pathname.startsWith(`/${lang}`) ? pathname.slice(lang.length + 1) : pathname;
}

function isProjectPath(pathname: string, lang: string): boolean {
  const path = stripLocale(pathname, lang);
  if (path === "" || path === "/") {
    return true;
  }
  return path === ProtectedPaths.PROJECT || path.startsWith(`${ProtectedPaths.PROJECT}/`);
}

export function useProjectDocumentTitle(lang: string): void {
  const pathname = usePathname();
  const currentProject = ProjectStore((state) => state.currentProject);
  const tenant = useBrand();

  useEffect(() => {
    if (!currentProject || !isProjectPath(pathname, lang)) {
      return;
    }
    document.title = `${currentProject.name} - ${tenant?.name ?? Globals.COMPANY.NAME}`;
  }, [pathname, lang, currentProject, tenant]);
}
